import type { SaferGamblingConfig } from '../../saferGambling.types.ts';
import { ROUTES } from './routes/routes.ts';

const SAFER_GAMBLING: SaferGamblingConfig = {
  showRealityCheck: true,
  depositLimitsRequireAcceptance: true,
  depositLimitAmountMax: { DAY: 5000, WEEK: 5000, MONTH: 5000 },
  showBreakToolsNotSetStatus: false,
  preselectBreakToolPeriod: true,
  disableBreakToolConfirmUntilValid: false,
  resetBreakToolFormOnClose: false,
  breakToolConfirmation: {
    enabled: false,
    supportTeamHref: 'https://lottolanduk.custhelp.com/app/ask',
  },
  coolOffUnit: 'hours',
  coolOffFallback: 24,
  coolOffStatusKeys: {
    pendingRaise: 'pending_raise_24h',
    pendingRemoval: 'pending_removal_24h',
  },
  depositLimitStatusIndicatorColor: '#1e7afd',
  learnMoreHref: ROUTES.FOOTER.NAVIGATION.GAMBLE_SAFELY.GAMBLE_SAFELY,
  otherResources: [
    {
      translationKey: 'gamstop',
      href: ROUTES.FOOTER.LEGAL.GAMSTOP,
      trackName: 'GamStop',
    },
    {
      translationKey: 'gamcare',
      href: ROUTES.FOOTER.LEGAL.GAMCARE,
      trackName: 'GamCare',
    },
    {
      translationKey: 'gambleaware',
      href: ROUTES.FOOTER.LEGAL.GAMBLE_AWARE,
      trackName: 'GambleAware',
    },
  ],
  timeOutPeriods: ['P1D', 'P1W', 'P1M', 'P6W'],
  timeOutPeriodLabelKeys: {
    P1D: '24_hours',
    P1W: '7_days',
    P1M: '1_month',
    P6W: '6_weeks',
  },
  selfExclusionPeriods: ['P6M', 'P9M', 'P1Y', 'P2Y', 'P5Y'],
};

export { SAFER_GAMBLING };
